<template>
  <div class="col-xl-12 text-start">
    <div class="card">
      <div class="card-header">
        <h5 class="mb-0 p-0">
          <button class="btn btn-link ps-0" :aria-expanded="isActive ? 'true' : 'false'" aria-controls="collapseicon1"
            :class="[isActive ? 'active' : '', 'collapsible']" v-on:click="toggle">Categories</button>
        </h5>
      </div>
      <div class="collapse show" id="collapseicon1" :class="[isActive ? 'block' : 'none', 'content']" v-show="isActive">
        <div class="categories">
          <div class="learning-header"><span class="f-w-600">Design</span></div>
          <ul>
            <li><a href="#">UI Design </a><span class="badge badge-primary pull-right">28</span></li>
            <li><a href="#">UX Design </a><span class="badge badge-primary pull-right">35</span></li>
            <li><a href="#">Interface Design </a><span class="badge badge-primary pull-right">17</span></li>
            <li><a href="#">User Experience </a><span class="badge badge-primary pull-right">26</span></li>
          </ul>
        </div>
        <div class="categories pt-0">
          <div class="learning-header"><span class="f-w-600">Development</span></div>
          <ul>
            <li><a href="#">Frontend Development</a><span class="badge badge-primary pull-right">48</span></li>
            <li><a href="#">Backend Development</a><span class="badge badge-primary pull-right">19</span></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <upcomingCourses />
</template>
<script>
import upcomingCourses from "./upcomingCourses.vue"
export default {
  components: { upcomingCourses },
  methods: {
    toggle() {
      this.isActive = !this.isActive
    },
  },
  data() {
    return {
      isActive: true,
    }
  }
}
</script>